import React from 'react'

export const Loading = () => {
  return (
    <div className="loading">
      <div></div>
    </div>
  )
}
